import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAt,
  faKey,
  faUser,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import FormInput from "../../utils/components/FormInput/FormInput";
import Header from "../../utils/components/Header/Header";
import Endpoints from "../../utils/repository/Endpoints";
import { registrationRequest } from "./registerSlice";
import Swal from "sweetalert2";

const Registration = () => {
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const dispatch = useDispatch();

  const isValidPassword = (password) => {
    const isLongEnough = password.length >= 8;
    const hasSpecialChar = /[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>]/.test(
      password
    );

    return isLongEnough && hasSpecialChar;
  };

  const getValidationErrors = () => {
    let errors = [];

    if (!first_name.trim()) errors.push("Vorname ist erforderlich.");
    if (!last_name.trim()) errors.push("Nachname ist erforderlich.");
    if (!email.trim()) errors.push("E-Mail ist erforderlich.");
    if (!password.trim()) errors.push("Passwort ist erforderlich.");

    return errors;
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const errors = getValidationErrors();

    if (errors.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Bitte füllen Sie alle Angaben korrekt aus: ",
        allowOutsideClick: false,
        html:
          `<ul style="list-style-position: inside; margin-left: 0; text-align: left;">` +
          errors.map((error) => `<li>${error}</li>`).join("") +
          `</ul>`,
      });
      setIsSubmitting(false);
      return;
    }
    if (!isValidPassword(password)) {
      Swal.fire({
        icon: "warning",
        title: "Ungültiges Passwortformat",
        allowOutsideClick: false,
        html:
          `<ul style="list-style-position: inside; margin-left: 0; text-align: left;">` +
          "Das Passwort muss mindestens 8 Zeichen und ein Sonderzeichen enthalten. Z.B. (&/$/@/%)." +
          `</ul>`,
      });
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);
    dispatch(registrationRequest());

    const payload = JSON.stringify({ first_name, last_name, email, password });

    try {
      const response = await fetch(Endpoints.api + Endpoints.register, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      });

      const data = response.json();
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Erfolgreiche Registrierung",
          text: "Bitte loggen Sie sich ein",
          allowOutsideClick: false,
          timer: 2000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            navigate("/admin/dashboard");
          },
        }).then(() => {
          navigate("/login");
        });
      } else {
        throw new Error(
          data.message || "Die E-Mail Adresse ist bereits registriert!"
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <>
      <Header />
      <div
        id="event"
        style={{
          marginTop: 10,
          padding: 10,
          overflow: "hidden",
          height: "auto",
        }}
      >
        <div
          className={isPortrait ? "container-fluid" : "container"}
          style={{ maxWidth: 750 }}
        >
          <div className="display-6 mb-3">Registrieren</div>
          <form onSubmit={onSubmit}>
            {" "}
            <FormInput
              type="text"
              id="first_name"
              placeholder=""
              label="Vorname"
              hint=""
              icon={faUser}
              value={first_name}
              setValue={setFirstName}
              required
            />
            <FormInput
              type="text"
              id="last_name"
              placeholder="Doe"
              label="Nachname"
              hint=""
              icon={faUser}
              value={last_name}
              setValue={setLastName}
              required
            />
            <FormInput
              type="email"
              id="user_email"
              placeholder="name@example.com"
              label="Email address"
              hint=""
              icon={faAt}
              value={email}
              setValue={setEmail}
              required
            />
            <FormInput
              type="password"
              id="user_password"
              placeholder="xxxxx"
              label="Passwort"
              hint=""
              icon={faKey}
              value={password}
              setValue={setPassword}
              required
            />
            <div
              className="text-muted"
              style={{ fontSize: 12, marginTop: -10 }}
            >
              (Das Passwort muss mindestens 8 Zeichen und ein Sonderzeichen
              enthalten. Z.B. (&/$/@/%).)
            </div>
            <div
              className="d-flex justify-content-end"
              style={{ marginTop: 10 }}
            >
              {isSubmitting ? (
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    height: 50,
                    width: "750px",
                    transition: "0.3s",
                    backgroundColor: "#332885",
                    color: "white",
                    border: "1px solid #332885",
                    borderRadius: 5,
                  }}
                  id="register_submitting"
                >
                  <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Wird geladen...</span>
                  </div>
                </div>
              ) : (
                <button
                  type="submit"
                  style={{
                    height: 50,
                    width: "750px",
                    transition: "0.3s",
                    backgroundColor: "#332885",
                    color: "white",
                    border: "1px solid #332885",
                    borderRadius: 5,
                  }}
                >
                  Registrieren <FontAwesomeIcon icon={faUserPlus} />
                </button>
              )}
            </div>
          </form>
          <div className="mt-4 text-center">
            <span>Sie haben bereits ein Konto? </span>
            <Link
              to="/login"
              style={{ color: "#332885", textDecoration: "none" }}
            >
              Hier login
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Registration;
